import React from 'react';
import { setFormField } from "../../../store/reducers/registrationSlice";
import { useFormContext } from 'react-hook-form';

const Step1Finalisation = ({
  formFields,
  dispatch,
  translate,
  language_code,
  fields,
  files = [],
  handleFileChange,
  handleRemoveFile,
  fileInputRef
}) => {
  const { register, formState: { errors }, setValue } = useFormContext();

  return (
    <>
      {fields.map(field => {
        const label = translate('signup', language_code.lang)[field];
        const isBooleanSelect = ['isProducer', 'isSpeculator', 'isTrader', 'isTransformer', 'isWorker'].includes(field);
        const isTextarea = field === 'wishesWhenRegistering';

        return (
          <div key={field} className="signup-field mt-2">
            <label htmlFor={`signup-${field}`} className="signup-label">{label}</label>

            {isBooleanSelect ? (
              <select
                id={`signup-${field}`}
                {...register(field, {
                  required: `${translate('errors', language_code.lang).form_input_errors.the_field} ${label} ${translate('errors', language_code.lang).form_input_errors.is_required}`,
                })}
                defaultValue={formFields[field] || ''}
                onChange={e => {
                  const value = e.target.value;
                  setValue(field, value, { shouldValidate: true });
                  dispatch(setFormField({ field, value }));
                }}
              >
                <option value="">
                  {translate('signup', language_code.lang).select_placeholder}
                </option>
                <option value="true">{translate('signup', language_code.lang).yes}</option>
                <option value="false">{translate('signup', language_code.lang).no}</option>
              </select>
            ) : isTextarea ? (
              <textarea
                id={`signup-${field}`}
                className="signup-textarea"
                rows={4}
                {...register(field, {
                  required: `${translate('errors', language_code.lang).form_input_errors.the_field} ${label} ${translate('errors', language_code.lang).form_input_errors.is_required}`,
                })}
                defaultValue={formFields[field] || ''}
                onChange={e => {
                  const value = e.target.value;
                  setValue(field, value, { shouldValidate: true });
                  dispatch(setFormField({ field, value }));
                }}
              />
            ) : (
              <input
                id={`signup-${field}`}
                type="text"
                {...register(field, {
                  required: `${translate('errors', language_code.lang).form_input_errors.the_field} ${label} ${translate('errors', language_code.lang).form_input_errors.is_required}`,
                })}
                defaultValue={formFields[field] || ''}
                onChange={e => {
                  const value = e.target.value;
                  setValue(field, value, { shouldValidate: true });
                  dispatch(setFormField({ field, value }));
                }}
              />
            )}

            {errors[field] && (
              <p className="text-danger">{errors[field].message}</p>
            )}
          </div>
        );
      })}    
    </>
  );
};

export default Step1Finalisation;
